// src/redux/rootReducer.js

import { combineReducers } from "redux";
import authSlice from "./slices/authSlice";
import applicationsSlice from "./slices/applicationsSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  applications: applicationsSlice,
});

export default rootReducer;
